<div class="main-title">
    <h2 class="heading" [attr.data-test-id]="testId + '.title'">Controlling Manager</h2>
    <p [attr.data-test-id]="testId + '.subtitle'">A single individual with significant responsibility to control, manage, or direct a legal
        entity customer (e.g., a Chief Executive Officer, Chief Financial Officer, Chief Operating Officer, Managing Member, General Partner, President,
        Vice President, Treasurer or any other individual who regularly performs similar functions)</p>
</div>

<form #companyControllingManagerForm="ngForm" [attr.data-test-id]="testId + '.form'">
    <div class="m-form__group">
        <div class="row mb-32">
            <div class="col-sm-6">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.manager-type-label'">Select Controlling Manager</mat-label>
                    <mat-select name="controllingManagerType"
                                [(ngModel)]="controllingManagerTypeValue" required #controllingManagerType="ngModel"
                                (selectionChange)="updateControllingManager()"
                                [attr.data-test-id]="testId + '.manager-type-select'">
                        <mat-option *ngFor="let manager of controllingManagerTypeArr" [value]="manager.value"
                                    [attr.data-test-id]="testId + '.manager-type-option.' + manager.value?.toLowerCase()?.replace(' ', '-')">
                            {{ manager.value }}
                        </mat-option>
                        <mat-option [value]="'SE'" [attr.data-test-id]="testId + '.manager-type-option.someone-else'">Someone Else</mat-option>
                    </mat-select>
                    <mat-error *ngIf="controllingManagerType.hasError('required')" [attr.data-test-id]="testId + '.manager-type.required-error'">Please select a controlling manager.</mat-error>
                </mat-form-field>
            </div>

            <ng-container *ngIf="controllingManagerTypeValue === 'SE'">
                <div class="col-sm-6">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.first-name-label'">First Name</mat-label>
                        <input matInput type="text" name="firstName" alphabetOnly
                               autocomplete="off" [(ngModel)]="controllingManager.firstName" #firstName="ngModel"
                               required [attr.data-test-id]="testId + '.first-name-input'">
                        <mat-error *ngIf="firstName.hasError('required')" [attr.data-test-id]="testId + '.first-name.required-error'">Please enter the first name.</mat-error>
                        <mat-error *ngIf="firstName.hasError('whitespace')" [attr.data-test-id]="testId + '.first-name.whitespace-error'">Remove any extra spaces at the beginning or end.</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.last-name-label'">Last Name</mat-label>
                        <input matInput type="text" name="lastName" alphabetOnly
                               autocomplete="off" [(ngModel)]="controllingManager.lastName" #lastName="ngModel"
                               required [attr.data-test-id]="testId + '.last-name-input'">
                        <mat-error *ngIf="lastName.hasError('required')" [attr.data-test-id]="testId + '.last-name.required-error'">Please enter the last name.</mat-error>
                        <mat-error *ngIf="lastName.hasError('whitespace')" [attr.data-test-id]="testId + '.last-name.whitespace-error'">Remove any extra spaces at the beginning or end.</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.title-label'">Title</mat-label>
                        <input matInput type="text" name="title"
                               autocomplete="off" [(ngModel)]="controllingManager.title" #title="ngModel"
                               required [attr.data-test-id]="testId + '.title-input'">
                        <mat-error *ngIf="title.hasError('required')" [attr.data-test-id]="testId + '.title.required-error'">Please enter the title.</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <creditsnap-ssn [(ngModel)]="controllingManager.ssn" name="controllingManagerSSN"
                                    [attr.data-test-id]="testId + '.ssn'"></creditsnap-ssn>
                </div>

                <div class="col-sm-10">
                    <creditsnap-address id="controllingManagerAddress" [(ngModel)]="controllingManager.address"
                                        name="address"
                                        [attr.data-test-id]="testId + '.address'"></creditsnap-address>
                </div>
                <div class="col-sm-2">
                    <mat-form-field class="mat-form-field-fluid" [attr.data-test-id]="testId + '.unit-field'">
                        <mat-label>Unit #</mat-label>
                        <input #unit="ngModel" [(ngModel)]="controllingManager.address.addressLine2"
                               autocomplete="new-unit" matInput
                               name="unit" trim type="text"
                               [attr.data-test-id]="testId + '.unit-input'"/>
                    </mat-form-field>
                </div>
            </ng-container>
        </div>
    </div>
</form>
